import { render, staticRenderFns } from "./bubble.vue?vue&type=template&id=22ef20be&scoped=true&"
import script from "./bubble.vue?vue&type=script&lang=js&"
export * from "./bubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ef20be",
  null
  
)

export default component.exports